import { DeviceDetailsWebComponent } from './component/DeviceDetailsWebComponent';

export { DeviceDetailsWebComponent };
